export const get_valid_trading_days = `query get_valid_trading_days{
    get_valid_trading_days
}`;
